import React from 'react';
import { TagFeedback, Text } from '@spark';
import {
  describeMeasuredRunOutcome,
  historyStatusLabel,
  historyStatusVariant,
} from './data/measuredRunMetrics';

function formatUsd(value) {
  if (value == null) return '-';
  return `$${value}`;
}

function runDetailLine(run, outcome) {
  const sku = [run.cloud_provider, run.instance_type].filter(Boolean).join('/');
  const parts = [sku || null, `est ${formatUsd(run.estimated_cost_usd)}`];
  if (run.actual_cost_usd != null) {
    parts.push(`actual ${formatUsd(run.actual_cost_usd)}`);
  }
  if (outcome?.kind === 'washout' || (outcome?.errors > 0 && !outcome.hasLatency)) {
    parts.push(`${Number(outcome.errors || 0).toLocaleString()} failed`);
    parts.push('no latency');
  } else if (outcome?.kind === 'partial') {
    parts.push(`${Number(outcome.errors || 0).toLocaleString()} failed`);
  }
  return parts.filter(Boolean).join(' · ');
}

export default function MeasuredRunsHistory({
  runs = [],
  liveStatus,
}) {
  if (!runs.length && !liveStatus) {
    return null;
  }

  return (
    <div style={{ marginTop: 24 }}>
      <Text variant="h4-bold">Measured serving-perf</Text>
      <Text variant="base-regular" color="secondary" style={{ display: 'block', marginBottom: 8 }}>
        Serving-perf runs for this version. Separate from the catalog baseline above.
      </Text>
      {liveStatus?.status && (
        <Text variant="base-regular">
          Live: {liveStatus.status}
          {liveStatus.error ? ` - ${liveStatus.error}` : ''}
        </Text>
      )}
      <ul style={{ paddingLeft: 18, marginTop: 8 }}>
        {runs.map((run) => {
          const outcome = describeMeasuredRunOutcome(run);
          return (
            <li key={run.run_id} style={{ marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <TagFeedback
                  label={historyStatusLabel(outcome)}
                  variant={historyStatusVariant(outcome)}
                  showIcon
                />
                <Text variant="base-regular">
                  {runDetailLine(run, outcome)}
                </Text>
              </div>
              {outcome?.message && outcome.kind !== 'ok' && outcome.kind !== 'in_progress' && (
                <Text variant="detail-regular" color="secondary" style={{ display: 'block', marginTop: 4 }}>
                  {outcome.message}
                </Text>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
